import React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import "react-confirm-alert/src/react-confirm-alert.css";
import { fetchQuizData, updateStarted, updateResume } from "../../actions/quiz";
import { AppState } from "../../reducers";
import QuestionList from "./questionList";
import Question from "./question";
import FinishedQuiz from "./FinishedQuiz";
import { saveQuiz, deleteQuizProgressData, completeQuiz } from "../../api";
import Spinner from "../spinner";
import Latex from "../latex";
import { allowSound } from "../../utils/functions";
import ErrorBoundary from "./errorBoundary";
import {
  deleteOldQuiz,
  email,
  resumeQuizTitle,
  sendEmail,
  startQuizTitle,
  userId,
  userName,
} from "../../utils/constants";
import SoundButton from "./SoundButton";
import StartQuiz from "./StartQuiz";

export const Quiz = (props: any) => {
  const {
    dispatch,
    quizId: id,
    quizType: type,
    data,
    flags,
    answers,
    attempts,
    started,
    fetchQuizLoading,
    resume,
    startQuizTime,
  } = props;
  const [idx, setIdx] = useState(0);
  const [finish, setFinish] = useState(false);
  const [inProgress, setProgress] = useState(true);
  const [progressStatus, setProgressStatus] = useState(0);
  const [indexFlag, updateFlag] = useState(true);
  const [soundFlag, updateSoundFlag] = useState(!allowSound() ? "no" : "yes");

  useEffect(() => {
    dispatch(fetchQuizData({ id, type }));
  }, [dispatch, id, type]);

  const handleNext = () => {
    setIdx(idx + 1);
  };
  const handleIdx = (i: any) => {
    setIdx(i);
  };
  const setUpdateSoundFlag = (val: any) => {
    localStorage.setItem("allowSound", !val ? "no" : "yes");
    updateSoundFlag(!val ? "no" : "yes");
  };

  const handleStart = () => {
    localStorage.setItem("QUIZ_STARTED", new Date().toISOString());
    dispatch(updateStarted(true));
    dispatch(updateResume(true));
  };

  const handleResume = () => {
    const startTime = startQuizTime ? startQuizTime : new Date().toISOString();
    localStorage.setItem("QUIZ_STARTED", startTime);
    dispatch(updateResume(true));
  };

  const goToNextUnsolved = () => {
    for (let i = idx + 1; i < data.questions.length; i++) {
      const question = data.questions[i];
      const questionId = question._id;
      if (answers[questionId]?.ans === null && !flags.includes(questionId)) {
        handleIdx(i);
        return;
      }
    }
    for (let i = 0; i < idx; i++) {
      const question = data.questions[i];
      const questionId = question._id;
      if (answers[questionId]?.ans === null && !flags.includes(questionId)) {
        handleIdx(i);
        return;
      }
    }
    for (let i = 0; i < data.questions.length; i++) {
      const question = data.questions[i];
      const questionId = question._id;
      if (flags.includes(questionId)) {
        handleIdx(i);
        return;
      }
    }
  };

  const handleFinish = (checkFlag = true) => {
    let index;
    if (flags.length > 0 && checkFlag) {
      let foundFlag = false;
      data.questions.find((q: any, i: number) => {
        if (flags.includes(q._id) && !foundFlag) {
          foundFlag = true;
          index = i;
          return true;
        }
        return false;
      });
      let setIndex = index === 0 ? 0 : index || idx;
      setIdx(setIndex);
    } else {
      let filterQuestionObj: any = {};
      let maxFirstCount = 0;
      let maxOthersCount = 0;
      let info: any = {
        user_id: Number(userId),
        course_id: data.course_id,
        quiz_id: data.id,
        quiz_pro_id: data.quiz_pro_id,
        unique: 0,
        lesson_id: data.lesson_id,
        quiz_nonce: data.quiz_nonce,

        questions: data.questions.map((obj: any) => {
          let correctAns =
            answers[obj._id] &&
            answers[obj._id].ans &&
            answers[obj._id].ans === true
              ? true
              : false;
          filterQuestionObj[obj._id] = {
            type: obj._answerType,
            title: obj.question_post_title || "",
            question_id: obj.question_id,
            question_pro_id: obj._id,
            attempts: obj.retries - 1,
            sortIndex: obj.sortIndex,
            time:
              answers[obj._id] && answers[obj._id].duration
                ? answers[obj._id].duration
                : 0,
            correct: correctAns,
            first:
              obj.retries - attempts[obj._id] === 1 && correctAns
                ? true
                : false,
            other:
              obj.retries - attempts[obj._id] !== 1 && correctAns
                ? true
                : false,
            skip:
              answers[obj._id] && answers[obj._id].ans === null ? true : false,
            tries:
              answers[obj._id] && answers[obj._id].ans === null
                ? 0
                : obj.retries - attempts[obj._id] === 1
                ? 0
                : obj.retries - attempts[obj._id] - 1,
            points:
              answers[obj._id] &&
              answers[obj._id].ans &&
              answers[obj._id].ans === true
                ? 1
                : 0,
            total_points: 1,
          };
          if (filterQuestionObj[obj._id]["first"] === true) {
            maxFirstCount += 1;
          }
          if (filterQuestionObj[obj._id]["other"] === true) {
            maxOthersCount += 1;
          }
          return {
            [obj._id]: {
              type: obj._answerType,
              title: obj.question_post_title || "",
              question_id: obj.question_id,
              question_pro_id: obj._id,
              attempts: obj.retries,
              time:
                answers[obj._id] && answers[obj._id].duration
                  ? answers[obj._id].duration
                  : 0,
              correct:
                answers[obj._id] &&
                answers[obj._id].ans &&
                answers[obj._id].ans === true
                  ? true
                  : false,
              first: answers.turn === 1 || false,
              other: answers.turn === 2 || false,
              skip: answers.ans === null || false,
              tries: obj.retries - attempts[obj._id],
              points: answers.ans === true ? 1 : 0,
              total_points: 1,
            },
          };
        }),
      };
      info["questions"] = filterQuestionObj;
      info["maxFirstCount"] = maxFirstCount;
      info["maxOthersCount"] = maxOthersCount;
      info["reportsData"] = finishQuizAnalyticData();
      info["deleteOldQuiz"] = deleteOldQuiz;
      info["sendEmail"] = sendEmail;
      info["userName"] = userName;
      const emails: any = email;
      info["email"] = emails.split(",");
      let statusProgress = setInterval(function () {
        if (progressStatus < 95)
          setProgressStatus((progressStatus) => progressStatus + 1);
      }, 100);
      saveQuiz(info)
        .then((res) => {
          setProgressStatus(100);
          setTimeout(() => {
            clearInterval(statusProgress);
            setFinish(true);
            setProgress(false);
          }, 2000);
          deleteQuizProgressData({
            userID: Number(userId),
            quizID: data.id,
          }).catch((err) => {});
          completeQuiz(info).catch((err) => {});
        })
        .catch((err) => console.log("err", err));
      setFinish(true);
    }
  };
  const finishQuizAnalyticData = () => {
    let filterQuestionObj: any = {};
    let totalPoints = 0;
    let totalCorrectQuestions = 0;
    let totalQuizTime = 0;
    let info = {
      action: "ntml_wp_pro_quiz_completed_quiz",
      userId: Number(userId),
      course_id: data.course_id,
      quiz: data.id,
      quizId: data.quiz_pro_id,
      lesson_id: data.lesson_id,
      lesson: data.quiz_title_reports || "",
      lessonCategory:
        data.categories && data.categories[0] && data.categories[0].label
          ? data.categories[0].label
          : "",
      timespent: 0,
      quiz_nonce: data.quiz_nonce,
      results: data.questions.map((obj: any) => {
        const ansType = obj._answerType;
        const ansValue =
          answers[obj._id] && answers[obj._id].ans === true
            ? true
            : answers[obj._id].ans === false
            ? false
            : null;
        let data: any = {};
        if (ansValue === null) {
          obj._answerData.map((resp: any, index: any) => {
            data[index] = "";
            return resp;
          });
        } else if (ansValue === true) {
          totalPoints += 1;
          totalCorrectQuestions += 1;
          obj._answerData.map((resp: any, index: any) => {
            if (ansType === "multiple" || ansType === "single") {
              data[index] = obj._answerData.length === 1 ? 1 : resp._correct;
            } else {
              data[index] = answers[obj._id].answerVal || "";
            }
            return resp;
          });
        } else if (ansValue === false) {
          obj._answerData.map((resp: any, index: any) => {
            if (ansType === "multiple" || ansType === "single") {
              data[index] = 0;
            } else {
              data[index] = answers[obj._id].answerVal || "";
            }
            return resp;
          });
        }
        totalQuizTime +=
          answers[obj._id] && answers[obj._id].duration
            ? answers[obj._id].duration
            : 0;
        filterQuestionObj[obj._id] = {
          time:
            answers[obj._id] && answers[obj._id].duration
              ? answers[obj._id].duration
              : 0,
          points:
            answers[obj._id] &&
            answers[obj._id].ans &&
            answers[obj._id].ans === true
              ? 1
              : 0,
          correct:
            answers[obj._id] &&
            answers[obj._id].ans &&
            answers[obj._id].ans === true
              ? 1
              : 0,
          data,
          possiblePoints: 1,
        };
        return {};
      }),
    };
    const startDate = localStorage.getItem("QUIZ_STARTED");
    const startTime = startDate
      ? Math.round(new Date(startDate).getTime() / 1000)
      : 0;
    const endTime = Math.round(new Date().getTime() / 1000);
    info.timespent = totalQuizTime;

    filterQuestionObj.comp = {
      points: totalPoints,
      correctQuestions: totalCorrectQuestions,
      quizTime: totalQuizTime,
      quizStartTimestamp: startTime,
      quizEndTimestamp: endTime,
      results: Math.round(
        (totalCorrectQuestions / data.questions.length) * 100
      ),
      cats: {
        "0": Math.round((totalCorrectQuestions / data.questions.length) * 100),
      },
    };
    info.results = JSON.stringify(filterQuestionObj);
    return info;
  };

  const finalIdx =
    indexFlag &&
    idx === 0 &&
    data &&
    data.firstUnsolvedId &&
    data.firstUnsolvedId !== 0.1
      ? data.firstUnsolvedId
      : idx;
  const correctId =
    data && data.id && id
      ? Number(data.id) !== Number(id)
        ? false
        : true
      : true;
  if (idx !== finalIdx && indexFlag) {
    updateFlag(false);
    setIdx(finalIdx);
  }

  return fetchQuizLoading ? (
    <Spinner />
  ) : (
    <React.Fragment>
      {data && data.id && correctId ? (
        <div className="main">
          {!started ? (
            <StartQuiz
              data={data}
              title={startQuizTitle}
              onClick={handleStart}
            />
          ) : finish ? (
            <FinishedQuiz
              inProgress={inProgress}
              progressStatus={progressStatus}
              setIdx={setIdx}
              setQIndex={handleIdx}
              finalIdx={finalIdx}
            />
          ) : resume ? (
            <div>
              <Latex>
                <SoundButton
                  soundFlag={soundFlag}
                  onClick={() => setUpdateSoundFlag(!allowSound())}
                />
                <QuestionList
                  preview={false}
                  questions={data.questions}
                  setQIndex={handleIdx}
                  idx={finalIdx}
                />
                <ErrorBoundary>
                  <Question
                    key={finalIdx}
                    question={data.questions[finalIdx]}
                    idx={finalIdx}
                    goToNextUnsolved={goToNextUnsolved}
                    handleNext={handleNext}
                    count={data.questions.length}
                    handleFinish={handleFinish}
                    finishQuizAnalyticData={finishQuizAnalyticData}
                  />
                </ErrorBoundary>
              </Latex>
            </div>
          ) : (
            <StartQuiz
              onClick={handleResume}
              data={data}
              title={resumeQuizTitle}
            />
          )}
        </div>
      ) : correctId && data && data.success === false ? (
        <div>Something went wrong, please try again </div>
      ) : (
        <Spinner />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (store: AppState) => ({
  data: store.quiz.data,
  flags: store.quiz.flags,
  answers: store.quiz.answers,
  attempts: store.quiz.attempts,
  started: store.quiz.started,
  fetchQuizLoading: store.quiz.fetchQuizLoading,
  resume: store.quiz.resume,
  startQuizTime: store.quiz.startQuizTime,
});

export default connect(mapStateToProps)(Quiz);
